/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
 function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }

  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
      formatString = format || '${{amount}}';

  function defaultTo(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ',');
    decimal = defaultTo(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
        dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        centsAmount = parts[1] ? decimal + parts[1] : '';
    return dollarsAmount + centsAmount;
  }

  var value = '';

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;

    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;

    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', '.');
      break;

    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, ',', '.');
      break;

    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;

    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
  }

  if (formatString.indexOf('with_comma_separator') !== -1) {
    return formatString.replace(placeholderRegex, value).replace(',00', '');
  } else {
    return formatString.replace(placeholderRegex, value).replace('.00', '');
  }
}

 $('.bad_p_wrap .product_atc button').click(function(){
    var added_item_html = $(this).next().html();
    var count_added_productt = $('.b_cart_wrap .empty-product-container.added').length;
    $('.b_cart_wrap .empty-product-container').each(function(){
      if($(this).hasClass('added') == false){
        $(this).addClass('added');
        $(this).html(added_item_html);
        return false;
      }
    });
    addToCartStatus();
  });
  function addToCartStatus(){
    var count_added_product = $('.b_cart_wrap .empty-product-container.added').length;
    if(count_added_product == 3){
      $('.add_to_cart_bab').removeClass('disabled');
      $('.add_to_cart_bab').addClass('enable');  
      $('.add_to_cart_bab').text('Add to Bag');
      var total_price = 0;
      $('.empty-product-container.added .empty_product-price').each(function(){
       var item_price = parseInt($(this).text());
       total_price += item_price;
      });
      console.log('total_price '+total_price);
      var saving_price = (total_price * 15)/100;
      $('.savings-number').text(formatMoney(saving_price, window.theme.moneyFormat));
      $('.total-savings').removeClass('hidden');
      // console.log('saving_price '+Shopify.formatMoney(saving_price));
    }else if(count_added_product == 1){
      $('.add_to_cart_bab').addClass('disabled');
      $('.add_to_cart_bab').removeClass('enable');
      $('.add_to_cart_bab').text('Add 2 more items');
      $('.total-savings').addClass('hidden');
    }else if(count_added_product == 2){
      $('.add_to_cart_bab').addClass('disabled');
      $('.add_to_cart_bab').removeClass('enable');
      $('.add_to_cart_bab').text('Add 1 more item');
      $('.total-savings').addClass('hidden');
    }else{
      $('.add_to_cart_bab').addClass('disabled');
      $('.add_to_cart_bab').removeClass('enable');
      $('.add_to_cart_bab').text('Add your items');
      $('.total-savings').addClass('hidden');
    }
  }
  $(document).on('click','a.remove-button.show',function(){
    $(this).parents('.empty-product-container').removeClass('added');
    var rindex = $(this).parents('.empty-product-container').data('index');
    $(this).parents('.empty-product-container').html('<span class="empty-product"></span> <span class="empty-product-text">Item '+rindex+'</span> <a class="remove-button">Remove</a>');
    addToCartStatus();
  });
  
  $(document).on('click', '.add_to_cart_bab', function() {
    var idArr = [];
  
    // Loop through each element with the specified class and extract data
    $('.empty-product-container.added span.empty-product.filled').each(function() {
      var c_vid = $(this).data('vid'); // Extract variant ID
      var quantity = 1; // Set the quantity to 1 (or any other logic to determine quantity)
      
      // Push the object with id and quantity to the array
      idArr.push({
        id: c_vid,
        quantity: quantity
      });
    });
  
    console.log('bab_vide ', idArr); // Log the array of products
    addRegularItem(idArr); // Call the function to add items to the cart
  });
  
  function addRegularItem(idArr) {
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        items: idArr
      },
      dataType: 'json',
      success: function(response) {
        console.log('Items successfully added to the cart:', response);
        jQuery.ajax({
          url: `${Shopify.routes.root}cart.js`,
          method: 'GET',
          dataType: 'json',
          success: function(cartContent) {
            document.dispatchEvent(new CustomEvent("cart:refresh"));
            window.location.href = '/cart';
          },
          error: function(error) {
            console.error('Error fetching cart content:', error);
            // Handle the error appropriately
          }
        });
      },
      error: function(error) {
        console.error('Error adding items to the cart:', error);
        alert(error.responseJSON['description']); // Show the error message
      }
    });
  }
  


$(document).ready(function(){
  $('.Drawer__Close').click(function(){
     $('#sidebar-cart').attr('aria-hidden', true);
  })
})

